import React from 'react';
import { Heart } from 'lucide-react';
import KpiLogPage from './KpiLogPage';
import KpiHistoryPage from './KpiHistoryPage';

export const AcceptanceLogPage = () => (
  <KpiLogPage
    kpi="acceptance"
    apiPath="/locker/acceptance"
    eyebrow="Acceptance · Log a round"
    title="How accepting were you today?"
    subtitle="Resistance costs strokes. Acceptance buys options."
    icon={Heart}
  />
);

export const AcceptanceHistoryPage = () => (
  <KpiHistoryPage
    kpi="acceptance"
    apiPath="/locker/acceptance"
    newPath="/locker/acceptance/new"
    eyebrow="Acceptance · History"
    icon={Heart}
  />
);
